export function shouldRenderBanner(state) {
  const {
    app: { isEmbeddable, isChromeless, isAmp },
  } = state;
  return !isAmp && !isEmbeddable && !isChromeless;
}
